import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { TagButton } from '@prisjakt/ui/button/variants';
import VisibilityToggle from '../toggle';
import type { Category } from '../../types';
import { Clickable } from 'src/components/clickable';

import * as S from './styles';

interface SubCategoryInlineListProps {
  categories: Category[];
  limit?: number;
}

const SubCategoryInlineList: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<SubCategoryInlineListProps>>
> = props => {
  const [collapse, setCollapse] = React.useState(true);
  const { categories = [], limit = 6 } = props;
  const context = useAppContext();
  return (
    <S.RelatedResources>
      {categories.map((cat, index) =>
        index < limit || !collapse ? (
          <TagButton
            key={cat.id}
            container={Clickable}
            containerProps={{
              to: cat.pathName,
            }}
          >
            {cat.name}
          </TagButton>
        ) : null
      )}
      {categories && categories.length > limit && (
        <VisibilityToggle
          styling="small"
          active={!collapse}
          onToggle={() => setCollapse(!collapse)}
          label={
            collapse
              ? context.t('category', 'subcategories.show-more')
              : context.t('category', 'subcategories.show-less')
          }
        />
      )}
    </S.RelatedResources>
  );
};

export default SubCategoryInlineList;
